import template from "./reset-password.html";
import {resetPasswordController} from "./reset-password.controller";

const ResetPasswordComponent = {
    template,
    controller: resetPasswordController,
    controllerAs: "resetPassword"
};

export default ResetPasswordComponent;


// WEBPACK FOOTER //
// ./sources/components/auth/reset-password/reset-password.component.js